const toastReducer = (
    state = {
        show: false,
        message: "",
    },
    action,
) => {
    switch (action.type) {
        case "TOAST_SHOW":
            state = {
                show: true,
                message: action.payload.message,
                type: action.payload.type,
            };
            break;
        case "TOAST_HIDE":
            state = {
                ...state,
                show: false,
            };
            break;
        default:
            return state;
    }
    return state;
};

export default toastReducer;
